import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { ListItem } from 'react-toolbox/lib/list'
import { Avatar } from 'react-toolbox/lib/avatar'
import { getDateString } from 'helpers/DateUtil'
import { branch, renderComponent } from 'recompose'
import * as R from 'ramda'

import styles from './styles.scss'

const DefaultAvatar = () => <Avatar icon='person'/>
const ImageAvatar = (props) => <Avatar image={props.image}/>

const UserAvatar = branch(
  (image) => R.isNil(image),
  renderComponent(DefaultAvatar)
)(ImageAvatar)

const CommentItem = ({
  image,
  name,
  comment,
  date
}) => (
  <ListItem
    theme={styles}
    avatar={<UserAvatar image={image}/>}
    caption={name}
    legend={comment}
    rightActions={[<span>{getDateString(date)}</span>]}
  />
)

CommentItem.propTypes = {
  name: PropTypes.string.isRequired,
  comment: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  image: PropTypes.string
}

export default CSSModules(CommentItem, styles)

